import { useUser } from '../../contexts/UserContext';

export interface AdminRoleHook {
  isAdmin: boolean;
  isViewer: boolean;
  role: 'admin' | 'viewer';
  canEdit: boolean;
  canDelete: boolean;
  canAdd: boolean;
}

export default function useAdminRole(): AdminRoleHook {
  const { role, viewerMode } = useUser();
  const effectiveRole = viewerMode ? 'viewer' : (role ?? 'viewer');
  
  const isAdmin = effectiveRole === 'admin';
  const isViewer = effectiveRole === 'viewer';
  
  // Permission flags for common actions
  const canEdit = isAdmin;
  const canDelete = isAdmin;
  const canAdd = isAdmin;

  return {
    isAdmin,
    isViewer,
    role: effectiveRole,
    canEdit,
    canDelete,
    canAdd
  };
}
